import { axiosClient } from "../api-client";

// type Prop = {
// 	config?: AxiosRequestConfig;
// 	body?: any;
// 	param?: string;
// };

export function GetNFTTemplates({ config, body }) {
	return axiosClient.get("/v1/nfttemplates", {
		...config,
		params: {
			fromAdmin: true,
			...config.params,
			...body,
		},
	});
}

export function UpdateNftTemplateHot({ config, body }) {
	const id = body._id;
	delete body._id;
	return axiosClient.patch("/v1/nfttemplates/" + id, body, config);
}

export function CreateRaffle({ config, body }) {
	return axiosClient.post("/v1/raffle", body, config);
}
export function GetRaffle({ config, body }) {
	return axiosClient.get("/v1/raffle", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetDrRaffle({ config, body }) {
	return axiosClient.get("/v1/raffle/draft", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function GetRaffleDetail({ config, body }) {
	return axiosClient.get(`/v1/raffle/${body}`, config);
}
export function RaffleUpdate({ config, body }) {
	const data = { ...body };
	delete data._id;
	return axiosClient.patch(`/v1/raffle/${body._id}`, data, config);
}

export function RaffleDelete({ config, body }) {
	return axiosClient.delete(`/v1/raffle/${body}`, config);
}
